<template>
  <div :class="classModifiers" @mouseover="onMouseOver" @mouseleave="onMouseLeave">
    <template v-if="layout === 'inline'">
      <span class="button-price__text">
        {{ text }}
      </span>
    </template>
    <template v-else>
      <span class="button-price__text">
        {{ text }}
        <span
          v-price-display.cents="price"
          v-if="price > 0"
          class="button-price__text--bold"
        ></span>
      </span>
      <template v-if="showWinOrSell">
        <transition name="button-price">
          <span v-if="hovered || active" class="button-price__price">
            <span class="button-price__price-alt" v-if="isSell"> Sell: {{ sell }}&cent; </span>
            <span v-else-if="isWin && price > 0" class="button-price__price-alt">
              Win: {{ multiple }}X
            </span>
            <span v-else-if="isWin && price === 0" class="button-price__price-alt">
              Set the Market
            </span>
          </span>
        </transition>
      </template>
    </template>
  </div>
</template>

<script src="./button-price.js"></script>
<style src="./button-price.scss" lang="scss"></style>
